import type { Customer } from '../types/customer.types';

/**
 * Helpers de presentación compartidos entre `CustomerListPage` y cualquier
 * otro módulo que liste/seleccione clientes (ej. el wizard de facturación) —
 * el shape de `Customer` es un discriminated union por `customerKind` desde
 * la migración a mdl03/core, así que ya no hay un campo único `name`/`taxId`.
 */

/** Nombre a mostrar según el tipo de cliente (Particular vs Comercial). */
export function displayCustomerName(customer: Customer): string {
  return customer.customerKind === 'BUSINESS'
    ? customer.legalName
    : `${customer.firstName} ${customer.lastName}`.trim();
}

/** Identificación a mostrar: RUC (Comercial) o cédula/pasaporte (Particular). */
export function displayCustomerTaxId(customer: Customer): string {
  return customer.customerKind === 'BUSINESS' ? customer.ruc : customer.idNumber;
}

/** Etiqueta legible del tipo de cliente. */
export function displayCustomerKind(customer: Customer): string {
  return customer.customerKind === 'BUSINESS' ? 'Comercial' : 'Particular';
}
